// Ações de conexão (Fase 4).
//
// Nenhuma delas fala com a Evolution direto: a chave da API não pode chegar ao
// browser, então tudo passa pela edge function `inbox-conexoes`, que resolve o
// segredo no Vault. O front só LÊ estado, e lê da view pública.
//
// ⚠️ `functions.invoke` engole a causa: em resposta não-2xx o SDK devolve só
// "Edge Function returned a non-2xx status code". O motivo real — "o nome da
// instância já está em uso", "a Evolution está fora do ar" — está em
// `error.context`. Mesmo padrão de `src/lib/gatewayResolver.ts`.

import { supabase } from '../../../src/lib/supabase';

async function chamar<T>(corpo: Record<string, unknown>): Promise<T> {
  const { data, error } = await supabase.functions.invoke('inbox-conexoes', { body: corpo });
  if (error) {
    const detalhe = await (error as any)?.context?.json?.().catch(() => null);
    throw new Error(detalhe?.error || error.message || 'Falha ao falar com a Evolution.');
  }
  return data as T;
}

export interface ConexaoCriada {
  id: string;
  display_name: string;
  external_id: string;
  status: string;
}

/** Cria a instância na Evolution e a linha da conexão. Webhook nasce desligado. */
export function criarConexaoWhatsApp(args: {
  display_name: string;
  instancia: string;
  base_url: string;
}): Promise<{ ok: true; conexao: ConexaoCriada }> {
  return chamar({ acao: 'criar', ...args });
}

export interface RespostaQr {
  ok: true;
  qr_base64?: string | null;
  qr_code?: string | null;
  pairing_code?: string | null;
  /** A instância já estava pareada: não vem QR, vem o estado. */
  ja_conectada?: boolean;
  status?: string;
}

export function obterQr(connectionId: string): Promise<RespostaQr> {
  return chamar({ acao: 'qr', connection_id: connectionId });
}

/** Polling do pareamento. Também atualiza status e heartbeat no banco. */
export function consultarEstado(connectionId: string): Promise<{ ok: true; status: string; detalhe: string | null }> {
  return chamar({ acao: 'estado', connection_id: connectionId });
}

export function reiniciarConexao(connectionId: string): Promise<{ ok: true }> {
  return chamar({ acao: 'reiniciar', connection_id: connectionId });
}

export function desconectarConexao(connectionId: string): Promise<{ ok: true }> {
  return chamar({ acao: 'desconectar', connection_id: connectionId });
}

/**
 * Liga ou desliga a ingestão desta instância.
 *
 * É a ação que faz mensagem real entrar no banco. Fica separada da criação de
 * propósito: com um número pessoal pareado, ligar isto gravaria conversa de
 * terceiros que nunca souberam disso — e a purga da Fase 15 ainda não existe.
 */
export function definirWebhook(connectionId: string, ligado: boolean): Promise<{ ok: true; ligado: boolean }> {
  return chamar({ acao: 'webhook', connection_id: connectionId, ligado });
}
